<template>
  <router-link tag="li" :to="path" @click.native="toggleMobileMenu ? toggleMobileMenu : ''">
    <a>{{ $t(`menus.${data.path}`) }}</a>
  </router-link>
</template>

<script>
export default {
  name: 'childLink',
  props: {
    data: Object,
    path: String,
    toggleMobileMenu: Function,
  },
};
</script>